import { createSelector, createStructuredSelector } from 'reselect';
import { initialState } from './reducer';
import { RootState } from '../../interface';
import { NameSpace, TokenState } from '../../enum';
import { selectPrimary } from '../AddressValidation/selector';

/**
 * Selects the container's state from RootState based on the given namespace
 * @param {RootState} state - rootstate of the app
 * @returns {AppState} - the App container's state
 */
export const selectState = (state: RootState) => state[NameSpace.APP] || initialState;

export const selectActiveView = createSelector(selectState, state => state.activeView);
export const selectLoading = createSelector(selectState, state => state.isLoading);
export const selectOverlayOpen = createSelector(selectState, state => state.isOverlayOpen);
export const selectOverlayLoaded = createSelector(selectState, state => state.isOverlayLoaded);
export const selectIsFriendsAndFamily = createSelector(selectState, state => state.ffTokenState === TokenState.VALID);

/**
 * Create a structured selector. (Map our selectors into specific keys in an object)
 * Used to connect the state to the container
 */
export const mapStateToProps = createStructuredSelector({
    activeView: selectActiveView,
    loading: selectLoading,
    overlayOpen: selectOverlayOpen,
    overlayLoaded: selectOverlayLoaded,
    isFriendsAndFamily: selectIsFriendsAndFamily,
    primaryCard: selectPrimary,
});
